import React from 'react';
import { CountrySelect } from './country-select';
export default React.memo(CountrySelect);
